<template>
  <div class="facets-type-radio">
    <div class="facets-type-radio__title">
      {{ title }}
    </div>
    <div class="facets-type-radio__body">
      <template v-for="option in options[type[0]]">
        <input
          :key="`${option.label}value`"
          :id="`${device}-${option.value}`"
          type="radio"
          :name="type[0]"
          :checked="option.selected"
          :value="option.value"
          @change="(event) => emitFacet(event, option.label)"
        />
        <label :for="`${device}-${option.value}`" :key="option.label">
          {{ option.label }}
        </label>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacetsTypeRadio',

  props: {
    type: {
      type: Array,
      required: true,
    },

    name: {
      type: Array,
      required: false,
      default: () => [],
    },

    options: {
      type: Object,
      required: true,
    },

    device: {
      type: String,
      required: false,
      default: 'mobile',
    },
  },

  data() {
    return {
      selectedItems: [],
    };
  },

  computed: {
    title() {
      return this.name[0] || this.type[0];
    },
  },

  mounted() {
    Object.keys(this.options).forEach((key) => {
      const options = this.options[key];

      options.forEach((option) => {
        if (!option.selected) {
          return;
        }

        let { value } = option;

        if (Array.isArray(value)) {
          value = value.join(',');
        }

        this.selectedItems.push(value);

        this.$emit('selected', {
          value: this.selectedItems,
          key: this.type[0],
          label: option.label,
          initial: true,
        });
      });
    });
  },

  methods: {
    emitFacet({ target }, label) {
      const { value } = target;

      this.selectedItems = [];

      if (target.checked) {
        this.selectedItems.push(value);
      } else {
        const index = this.selectedItems.indexOf(value);

        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
      }
      this.$emit('selected', {
        value: this.selectedItems,
        key: this.type[0],
        label,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .facets-type-radio {
    align-items: center;
    display: flex;

    &__title {
      font-weight: 500;
      height: 45px;
      text-transform: uppercase;
    }

    &__body {
      display: flex;

      input {
        left: -9999px;
        position: absolute;
      }

      label {
        @include font-size(eta, 20px);

        background-color: $color-lynch;
        border-radius: $global-radius-half;
        box-shadow: 0 4px 10px rgba(#CACACA, .5);
        color: $color-white;
        cursor: pointer;
        display: block;
        font-weight: 300;
        height: 30px;
        margin-left: $global-spacing-unit-half;
        min-width: 110px;
        overflow: hidden;
        padding: 5px 20px;
        position: relative;
        text-align: center;

        &:hover {
          background-color: $color-cerulean;
        }
      }

      input:checked + label {
        background-color: $color-cerulean;
        color: $color-white;
      }
    }

    @include mq($until: tablet) {
      display: block;

      &__title {
        display: none;
      }

      &__body {
        display: block;
        margin-left: -$global-spacing-unit-half;
        margin-right: -$global-spacing-unit-half;
        text-align: center;

        label {
          @include font-size(theta);

          background-color: $color-lynch;
          box-shadow: none;
          color: $color-white;
          display: inline-block;
          margin-bottom: 12px;
          margin-left: 0;
          max-width: 164px;
          width: 100%;

          &:last-child {
            margin-bottom: 0;
          }

          &:hover {
            background-color: $color-cerulean;
          }

          input:checked + & {
            background-color: $color-cerulean;
            color: $color-white;
          }
        }
      }
    }
  }
</style>
